// Author: Shubham Srivastava
// Env File to use for Production.

export const environment = {
  production: true,
  configType: false,
  // apiBaseUrl:' https://uat.theworldwidecard.net/api/front/bank',
  apiBaseUrl:'https://uat.theworldwidecard.net/api/v1.0/eBank',
  apiBaseUrl2:'https://uat.theworldwidecard.net/api/v1.0',
  setHeaderToken:true
};
